/***
 *
 *   HOME LAYOUT
 *   Main website layout
 *
 **********/

import { Fragment, type ComponentType } from 'react';
import { HomeNav, Footer, useLocation } from 'components/lib';

interface HomeLayoutProps {
  children: ComponentType<Record<string, unknown>>;
  data?: Record<string, unknown>;
}

export function HomeLayout(props: HomeLayoutProps) {
  const location = useLocation();
  const transparent = location?.pathname === '/' || location?.pathname === '/terms';
  const showHomeNav = location?.pathname !== '/maintenance';

  return (
    <Fragment>
      <main className="home">
        {showHomeNav && <HomeNav transparent={transparent} />}
        {<props.children {...props.data} />}
      </main>
      <Footer />
    </Fragment>
  );
}
